import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PortfolioTable from '../../components/portfolio/PortfolioTable';
import Loader from '../../components/loader/Loader';
import { Server } from '../../services/Server';
import './Portfolio.css';
import { Asset } from '../../../../api/src/interfaces/shared';
import { addCalculatedStats } from '../../components/portfolio/addCalculatedStats';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

interface Props {
  pageName: string;
}

interface State {
  assetsLoaded: boolean;
  assets: AssetWithCalculatedStats[];
}

export default class Portfolio extends Component<Props, State> {
  /*
    This component shows the users portfolio (a list of equities).
  */

  constructor(props: Props) {
    super(props);

    // Initialize the state with no equities and modal not showing.
    this.state = {
      assetsLoaded: false,
      assets: []
    };

    this.loadAssets();
  }

  loadAssets = () =>
    Server.getAssets()
      .then(assets => {
        this.assetsLoaded(assets);
      })
      .catch(error => {
        console.warn(error);
      });

  assetsLoaded = (assets: Asset[]) => {
    // Add calculated info about the asset
    const assetsWithCalculatedStats = assets.map(addCalculatedStats);

    this.setState({
      assetsLoaded: true,
      assets: assetsWithCalculatedStats
    });
  };

  render() {
    return (
      <Row>
        <div className="box float-left">
          <div className="header">
            <h2> {this.props.pageName} </h2>
          </div>
          {this.state.assetsLoaded ? (
            <PortfolioTable assets={this.state.assets} deletable />
          ) : (
            <Loader />
          )}
        </div>
      </Row>
    );
  }
}
